const COLLECTIONS = [
  { icon: 'ri-user-3-line', name: '人物合集', desc: '被反复点名的那些人设与翻车', posts: 128, hot: '连麦双方 · 删号导师' },
  { icon: 'ri-flag-2-line', name: '事件合集', desc: '年度名场面与没头没尾的瓜', posts: 214, hot: '撤投连坐 · 停更回归' },
  { icon: 'ri-time-line', name: '时间线合集', desc: '声明、实锤、删帖的时间排序', posts: 96, hot: '声明改口 · 补档时间轴' },
  { icon: 'ri-global-line', name: '地区合集', desc: '同一套剧本在不同城市上演', posts: 61, hot: '各城同款"代运营"' },
  { icon: 'ri-store-2-line', name: '行业合集', desc: '直播、带货、餐饮、教培样本', posts: 173, hot: '直播间控评 · 口头画饼' },
  { icon: 'ri-award-line', name: '年度盘点', desc: '年底把一年的事按热度归档', posts: 32, hot: '年度人物 · 年度名场面' }
];

export default function Collections() {
  return (
    <section id="collections" className="bg-band">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b-2 border-ink pb-3">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-folder-2-line text-xl text-verm" />
              <h2 className="font-display text-xl font-black md:text-2xl">合集索引 · 按主题收好</h2>
            </div>
            <p className="mt-1 text-sm text-ink/55">散落的帖子已按人物 / 事件 / 时间线归进合集，点进去从第一条开始看。</p>
          </div>
          <span className="flex items-center gap-1 text-sm text-ink/60">
            <i className="ri-folder-fill text-verm" /> 已收录 704 帖
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {COLLECTIONS.map((c) => (
            <a
              key={c.name}
              href="#collections"
              className="group flex items-start gap-4 border border-line bg-paper2 p-4 transition-colors hover:border-verm/50 hover:bg-verm-wash md:p-5"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-verm text-xl text-paper2">
                <i className={c.icon} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between">
                  <span className="font-display text-lg font-black group-hover:text-verm">{c.name}</span>
                  <span className="rounded-full bg-band px-2 py-0.5 text-[11px] font-bold text-verm">{c.posts} 帖</span>
                </span>
                <span className="mt-1 block text-sm text-ink/60">{c.desc}</span>
                <span className="mt-2.5 flex items-center gap-1 border-t border-dashed border-line pt-2.5 text-xs text-gold">
                  <i className="ri-fire-line" />
                  {c.hot}
                  <i className="ri-arrow-right-up-line ml-auto group-hover:text-verm" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}